export const ENQUEUE_PUBLISH_JOB = 'ENQUEUE_PUBLISH_JOB';
export const UPDATE_PUBLISH_JOB_PROGRESS = 'UPDATE_PUBLISH_JOB_PROGRESS';
export const REMOVE_PUBLISH_JOB = 'REMOVE_PUBLISH_JOB';

export const MARK_BANNER_LIST_STALE = 'MARK_BANNER_LIST_STALE';
export const CLEAR_BANNER_LIST_STALE = 'CLEAR_BANNER_LIST_STALE';
export const MARK_TEMPLATE_LIST_STALE = 'MARK_TEMPLATE_LIST_STALE';
export const CLEAR_TEMPLATE_LIST_STALE = 'CLEAR_TEMPLATE_LIST_STALE';
export const MARK_PAGES_LIST_STALE = 'MARK_PAGES_LIST_STALE';
export const CLEAR_PAGES_LIST_STALE = 'CLEAR_PAGES_LIST_STALE';
export const MARK_CATEGORIES_LIST_STALE = 'MARK_CATEGORIES_LIST_STALE';
export const CLEAR_CATEGORIES_LIST_STALE = 'CLEAR_CATEGORIES_LIST_STALE';
export const MARK_WIDGETS_LIST_STALE = 'MARK_WIDGETS_LIST_STALE';
export const CLEAR_WIDGETS_LIST_STALE = 'CLEAR_WIDGETS_LIST_STALE';
export const MARK_SEO_LIST_STALE = 'MARK_SEO_LIST_STALE';
export const CLEAR_SEO_LIST_STALE = 'CLEAR_SEO_LIST_STALE';
export const MARK_INFORMATION_POLICY_LIST_STALE = 'MARK_INFORMATION_POLICY_LIST_STALE';
export const CLEAR_INFORMATION_POLICY_LIST_STALE = 'CLEAR_INFORMATION_POLICY_LIST_STALE';
export const MARK_ADMIN_SETTINGS_STALE = 'MARK_ADMIN_SETTINGS_STALE';
export const CLEAR_ADMIN_SETTINGS_STALE = 'CLEAR_ADMIN_SETTINGS_STALE';
export const MARK_CONFIG_SETTINGS_STALE = 'MARK_CONFIG_SETTINGS_STALE';
export const CLEAR_CONFIG_SETTINGS_STALE = 'CLEAR_CONFIG_SETTINGS_STALE';

export const MARK_GALLERY_LIST_STALE = 'MARK_GALLERY_LIST_STALE';
export const CLEAR_GALLERY_LIST_STALE = 'CLEAR_GALLERY_LIST_STALE';
export const MARK_OFFICIAL_CONTACT_LIST_STALE = 'MARK_OFFICIAL_CONTACT_LIST_STALE';
export const CLEAR_OFFICIAL_CONTACT_LIST_STALE = 'CLEAR_OFFICIAL_CONTACT_LIST_STALE';
export const MARK_ADMINISTRATION_LIST_STALE = 'MARK_ADMINISTRATION_LIST_STALE';
export const CLEAR_ADMINISTRATION_LIST_STALE = 'CLEAR_ADMINISTRATION_LIST_STALE';
export const MARK_PARISH_PRIEST_LIST_STALE = 'MARK_PARISH_PRIEST_LIST_STALE';
export const CLEAR_PARISH_PRIEST_LIST_STALE = 'CLEAR_PARISH_PRIEST_LIST_STALE';
export const MARK_LEADERSHIP_HISTORY_LIST_STALE = 'MARK_LEADERSHIP_HISTORY_LIST_STALE';
export const CLEAR_LEADERSHIP_HISTORY_LIST_STALE = 'CLEAR_LEADERSHIP_HISTORY_LIST_STALE';
export const MARK_HOUSE_LIST_STALE = 'MARK_HOUSE_LIST_STALE';
export const CLEAR_HOUSE_LIST_STALE = 'CLEAR_HOUSE_LIST_STALE';
export const MARK_HISTORY_LIST_STALE = 'MARK_HISTORY_LIST_STALE';
export const CLEAR_HISTORY_LIST_STALE = 'CLEAR_HISTORY_LIST_STALE';
export const MARK_HIERARCHY_LIST_STALE = 'MARK_HIERARCHY_LIST_STALE';
export const CLEAR_HIERARCHY_LIST_STALE = 'CLEAR_HIERARCHY_LIST_STALE';
export const MARK_CHURCH_LIST_STALE = 'MARK_CHURCH_LIST_STALE';
export const CLEAR_CHURCH_LIST_STALE = 'CLEAR_CHURCH_LIST_STALE';
export const MARK_ORGANIZATION_LIST_STALE = 'MARK_ORGANIZATION_LIST_STALE';
export const CLEAR_ORGANIZATION_LIST_STALE = 'CLEAR_ORGANIZATION_LIST_STALE';
export const MARK_MEMBERS_LIST_STALE = 'MARK_MEMBERS_LIST_STALE';
export const CLEAR_MEMBERS_LIST_STALE = 'CLEAR_MEMBERS_LIST_STALE';
export const MARK_CHAPEL_LIST_STALE = 'MARK_CHAPEL_LIST_STALE';
export const CLEAR_CHAPEL_LIST_STALE = 'CLEAR_CHAPEL_LIST_STALE';
export const MARK_NEWS_LIST_STALE = 'MARK_NEWS_LIST_STALE';
export const CLEAR_NEWS_LIST_STALE = 'CLEAR_NEWS_LIST_STALE';
export const MARK_FESTIVALS_LIST_STALE = 'MARK_FESTIVALS_LIST_STALE';
export const CLEAR_FESTIVALS_LIST_STALE = 'CLEAR_FESTIVALS_LIST_STALE';
export const MARK_ADVERTISEMENT_LIST_STALE = 'MARK_ADVERTISEMENT_LIST_STALE';
export const CLEAR_ADVERTISEMENT_LIST_STALE = 'CLEAR_ADVERTISEMENT_LIST_STALE';
export const MARK_OCCASION_LIST_STALE = 'MARK_OCCASION_LIST_STALE';
export const CLEAR_OCCASION_LIST_STALE = 'CLEAR_OCCASION_LIST_STALE';
export const MARK_LIVE_STREAMING_LIST_STALE = 'MARK_LIVE_STREAMING_LIST_STALE';
export const CLEAR_LIVE_STREAMING_LIST_STALE = 'CLEAR_LIVE_STREAMING_LIST_STALE';
export const MARK_INCOME_PDF_LINK_LIST_STALE = 'MARK_INCOME_PDF_LINK_LIST_STALE';
export const CLEAR_INCOME_PDF_LINK_LIST_STALE = 'CLEAR_INCOME_PDF_LINK_LIST_STALE';
export const MARK_EVENTS_LIST_STALE = 'MARK_EVENTS_LIST_STALE';
export const CLEAR_EVENTS_LIST_STALE = 'CLEAR_EVENTS_LIST_STALE';
export const MARK_QUOTES_LIST_STALE = 'MARK_QUOTES_LIST_STALE';
export const CLEAR_QUOTES_LIST_STALE = 'CLEAR_QUOTES_LIST_STALE';
export const MARK_POSITION_LIST_STALE = 'MARK_POSITION_LIST_STALE';
export const CLEAR_POSITION_LIST_STALE = 'CLEAR_POSITION_LIST_STALE';
